import { KeywordButtonType } from "@components/Button/utils/types";
import KeywordFilter from "@features/mybt/components/KeywordFilter";
import { KeywordType } from "@features/mybt/components/KeywordFilter/utils/types";
import { BUTTON_CSS } from "@features/toolbar/ArticleToolbar/utils/constants";
import { FeedTag } from "@routes/Keyword/utils/types";
import { MYBT_EXCLUDE_KEYWORDS } from "@util/constant";
import { cn } from "@util/helpers";

export enum KeywordDisplayOption {
  First = "first",
  Rest = "rest",
  ToolBar = "toolbar",
}

export type ArticleKeywordsProps = {
  keywords: FeedTag[];
  keywordDisplayOption?: KeywordDisplayOption;
  keywordButtonType?: KeywordButtonType;
  rootClassName?: string;
  tagClassName?: string;
  firstKeyworkDisplayClassname?: string;
  toolTipClassName?: string;
  toolTipArrowClassName?: string;
  disableTooltip?: boolean;
  withGiftIcon?: boolean;
  disableBorder?: boolean;
  isPodcastToolbarKeyword?: boolean;
  isPodcastAudioArticle?: boolean;
  articleTitle?: string;
};

export default function ArticleKeywords({
  keywords,
  keywordDisplayOption,
  firstKeyworkDisplayClassname,
  rootClassName,
  tagClassName,
  toolTipClassName,
  toolTipArrowClassName,
  disableTooltip,
  disableBorder,
  keywordButtonType,
  isPodcastToolbarKeyword = false,
  isPodcastAudioArticle = false,
  articleTitle,
}: ArticleKeywordsProps): React.ReactElement {
  const tags = keywords.filter((tag) => {
    return !MYBT_EXCLUDE_KEYWORDS.some((t) => t === tag.name);
  });

  switch (keywordDisplayOption) {
    case KeywordDisplayOption.First:
      return (
        <div
          data-testid="article-keyword-filter-first"
          className={firstKeyworkDisplayClassname}
        >
          {tags && tags[0] ? (
            <KeywordFilter
              testId={"article-top-keyword"}
              tag={tags[0]}
              className={cn("inline-block bg-gray-250 p-3", rootClassName)}
              tagClassName={cn("!text-gray-850", tagClassName)}
              toolTipClassName={toolTipClassName}
              toolTipArrowClassName={toolTipArrowClassName}
              disableTooltip={disableTooltip}
              disableBorder={disableBorder}
              keywordButtonType={keywordButtonType}
            />
          ) : null}
        </div>
      );
    case KeywordDisplayOption.Rest:
      return (
        <div data-testid="article-keyword-filter-rest">
          {tags && tags.length > 1 && (
            <div className="mb-6 mt-3 border-t border-gray-75 pt-3">
              <h2 className="mb-3 font-poppins text-lg font-semibold">
                KEYWORDS IN THIS ARTICLE
              </h2>

              <div className="flex flex-wrap gap-3">
                {/* Skip the first keyword as it has already been displayed below the author details */}
                {tags.slice(1).map((keyword) => (
                  <KeywordFilter
                    key={keyword.id}
                    tag={keyword}
                    className="inline-block bg-gray-250 p-3"
                    tagClassName="!text-gray-850"
                    disableTooltip
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      );

    case KeywordDisplayOption.ToolBar:
      return (
        <KeywordFilter
          testId="keyword-button-component"
          tag={tags[0]}
          keywordButtonType={KeywordButtonType.version3}
          keywordType={KeywordType.noTag}
          disableTooltip
          buttonClassName={BUTTON_CSS}
          isPodcastToolbarKeyword={isPodcastToolbarKeyword}
          isPodcastAudioArticle={isPodcastAudioArticle}
          articleTitle={articleTitle}
        />
      );
    default:
      return <></>;
  }
}
